/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */

// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

let endTimeG;

function cutDownTime() {
  let nowTime = new Date();
  let endTime = new Date(endTimeG);

  let leftTime = endTime.getTime() - nowTime.getTime();
  if (leftTime < 0) {
    setupNewCountdown();
    leftTime = 0;
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60);
  leftH = leftH >= 10 ? leftH : "0" + leftH;
  leftM = leftM >= 10 ? leftM : "0" + leftM;
  leftS = leftS >= 10 ? leftS : "0" + leftS;

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  };
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9);
  const currentTime = new Date();
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
}
let intervalId;

function getCutDownTime() {
  setupNewCountdown();
  if (intervalId) clearInterval(intervalId);
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime();
    $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
    $(".sp_top_cut_down .sp_left_view .sp_minute").html(cutDownTimeText.minute);
    $(".sp_top_cut_down .sp_left_view .sp_second").html(cutDownTimeText.second);
  }, 1000);
}

getCutDownTime();

new Swiper(".sp-swiper2", {
  autoplay: true,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },

  slidesPerView: "auto",
  spaceBetween: 0,
  centeredSlides: true,
  loop: true,
  pagination: {
    el: ".sp-pagination",
    clickable: true,
  },
});

let swiper = new Swiper("#swiper-p1", {
  speed: 1,
  on: {
    slideChange: function (e) {
      $("#sp-color2 .option")
        .eq(e.activeIndex)
        .addClass("active")
        .siblings()
        .removeClass("active");
    },
  },
  spaceBetween: 20,
});

let spImgList = [
    "https://cdn.shopify.com/s/files/1/0660/2122/8780/files/202409042-p1-2.png",
  "https://cdn.shopify.com/s/files/1/0660/2122/8780/files/202409042-p1-3.png",
  "https://cdn.shopify.com/s/files/1/0660/2122/8780/files/202409042-p2-2.png",
  "https://cdn.shopify.com/s/files/1/0660/2122/8780/files/202409042-p1.png",
  "https://cdn.shopify.com/s/files/1/0660/2122/8780/files/202409042-p2.png",
  "https://cdn.shopify.com/s/files/1/0660/2122/8780/files/202409042-p3.png",

  "https://cdn.shopify.com/s/files/1/0660/2122/8780/files/202409042-p2-3.png",
  "https://cdn.shopify.com/s/files/1/0660/2122/8780/files/202409042-p3-2.png",
  "https://cdn.shopify.com/s/files/1/0660/2122/8780/files/202409042-p3-3.png",
];
let spBannerList = [
  "https://cdn.shopify.com/s/files/1/0660/2122/8780/files/202409042-b1.jpg",
  "https://cdn.shopify.com/s/files/1/0660/2122/8780/files/202409042-b2.jpg",
  "https://cdn.shopify.com/s/files/1/0660/2122/8780/files/202409042-b3.jpg",
  "https://cdn.shopify.com/s/files/1/0660/2122/8780/files/202409042-b4.jpg",
];

function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
    config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    preloadImages(spImgList);
    preloadImages(spBannerList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            3 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }
}

mainRender();

$("#sp-text1").arctext({
  radius: 200,
});
$("#sp-text2").arctext({
  radius: 180,
});


function showTip() {
  let result = $("#sp_price1").html();

  if (result >= 300) {
    $("#freeBtn").addClass("sp-free-btn");
  } else {
    $("#freeBtn").removeClass("sp-free-btn");
  }
}
let prods = window.product
function getCur(){
  let color2 = $('#sp-color2 div.active').attr('data-val')
  let color = $('#sp-color div.active').attr('data-val')
  let color3 = $('#sp-color3 div.active').attr('data-val')
  return prods.filter(item=> item.option1 == color2 && item.option2 == color)[0]
}
function changePrice(){
  let num = $('#calcNumber').val()
  let price = (getCur().price * num / 100).toFixed(2)
  let compare = (getCur().compare_at_price * num / 100).toFixed(2)
  // if(num == 1){
  //   price = (getCur().price * num / 100).toFixed(2)
  // }else if(num == 2){
  //   price = (getCur().price * num / 100 * 0.95).toFixed(2)
  // }else if(num == 3){
  //   price = (getCur().price * num / 100 * 0.9).toFixed(2)
  // }else {
  //   price = (getCur().price * num / 100 * 0.85).toFixed(2)
  // }
  // price = (price + '').replace('.', ',')
  // compare = (compare + '').replace('.', ',')
  $('#sp_price1').html(price)
  $('#sp_price2').html(compare)
  let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
  $(".product-part .price-group .sp-row span").html(off_font);
}
$('.sp-btn-style').click(function(){
  let num = $('#calcNumber').val()
  window.location.href = '/cart/' + getCur().id + ':' + num
})
$(".sp-reduce").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) - 1;
  if (num > 0) {
    input.value = num;
    changePrice();
    showTip();
  }
});
$(".sp-add").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) + 1;
  input.value = num;
  changePrice();
  showTip();
});

$(function () {
  $(".option").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    // style选项

    let numOptions = $("#sp-color2 .option.active").index();
    let colorOptions = $("#sp-color .option.active").index();
    let color3 = $("#sp-color3 .option.active").index();

    $(".product-part .swiper-slide")
      .find(`.sp-img:eq(${colorOptions})`)
      .addClass("active")
      .siblings()
      .removeClass("active");

    if (colorOptions == 0) {
      $(".product-part .sp-tip").css({
        top: "99px",
        left: "741px",
      });
      $(".product-part .sp-text1").css({
        top: "258px",
        left: "736px",
      });
      $(".product-part .sp-text2").css({
        top: "458px",
        left: "713px",
      });
      $(".product-part .sp-text3").hide();
    } else if (colorOptions == 1) {
    
        $(".product-part .sp-tip").css({
          top: "113px",
          left: "112px",
        });
        $(".product-part .sp-text1").css({
          top: "270px",
          left: "108px",
        });
        $(".product-part .sp-text2").css({
          top: "467px",
          left: "81px",
        });
      
      $(".product-part .sp-text3").hide();
    } else if (colorOptions == 2) {
      $(".product-part .sp-tip").css({
          top: "105px",
          left: "763px",
        });
        $(".product-part .sp-text1").css({
          top: "262px",
          left: "766px",
        });
        $(".product-part .sp-text2").css({
          top: "463px",
          left: "737px",
        });
      $(".product-part .sp-text3").show();
    }

    if(color3 == 0){
      $('.sp-round').css('display', 'none')
      $('.color-option1').attr('src', 'https://cdn.shopify.com/s/files/1/0660/2122/8780/files/202409042-p1-2.png')
      $('.color-option2').attr('src', 'https://cdn.shopify.com/s/files/1/0660/2122/8780/files/202409042-p2-2.png')
      $('.color-option3').attr('src', 'https://cdn.shopify.com/s/files/1/0660/2122/8780/files/202409042-p3-2.png')
    }else if(color3 == 1){
      $('.sp-round span').html('2')
      $('.sp-round').css('display', 'flex')
      $('.color-option1').attr('src', 'https://cdn.shopify.com/s/files/1/0660/2122/8780/files/202409042-p1-4.png')
      $('.color-option2').attr('src', 'https://cdn.shopify.com/s/files/1/0660/2122/8780/files/202409042-p2-4.png')
      $('.color-option3').attr('src', 'https://cdn.shopify.com/s/files/1/0660/2122/8780/files/202409042-p3-4.png')
    }else if(color3 == 2) {
      $('.sp-round span').html('4')
      $('.sp-round').css('display', 'flex')
      $('.color-option1').attr('src', 'https://cdn.shopify.com/s/files/1/0660/2122/8780/files/202409042-p1-4.png')
      $('.color-option2').attr('src', 'https://cdn.shopify.com/s/files/1/0660/2122/8780/files/202409042-p2-4.png')
      $('.color-option3').attr('src', 'https://cdn.shopify.com/s/files/1/0660/2122/8780/files/202409042-p3-4.png')
    }

    // $(".product-part .swiper-slide")
    //   .find(`.sp-tip:eq(${numOptions})`)
    //   .addClass("active")
    //   .siblings(".sp-tip")
    //   .removeClass("active");
    swiper.slideTo(numOptions);
    changePrice();
    showTip();
  });

  // style选项
  // // 处理加入购物车事件
  // function handleAddToCart(num) {
  //   if (num > 0) {
  //     $("#cardNum").html(num).show();
  //     $(".sp-top-btn").addClass("sp-high");
  //     $(".sp-top-btn span").html("Check out");
  //     $(".sp-header-top .sp-cart").addClass("on");
  //   } else {
  //     $("#cardNum").html(0).hide();

  //     $(".sp-top-btn").removeClass("sp-high");
  //     $(".sp-top-btn span").html("Buy now");
  //     $(".sp-header-top .sp-cart").removeClass("on");
  //   }
  // }
  // handleAddToCart(0);

  // 购物车加购动效
  $(".cart-btn").click(function () {
    $(this).children("img").addClass("on");
    $(".sp-header-top .sp-cart .num").show();
    setTimeout(function () {
      $(".cart-btn").children("img").removeClass("on");
    }, 500);
    $(".sp-header-top .sp-cart").addClass("on");
    setTimeout(function () {
      $(".sp-header-top .sp-cart").removeClass("on");
    }, 500);
  });
 
  $(".product-part .cart-btn").click(function () {
    var data = {
      id: getCur().id,
      quantity: $('#calcNumber').val(),
    };
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
          $("#cardNum").html(result.item_count);
        });
      },
      dataType: "json",
    });

    // var img = $(".product-part .p-img");
    var img = $(".product-part  .swiper-slide-active .sp-img.active");

    var flyer = img[0].cloneNode(true);
    flyer.classList.add("sp_clone");

    $(".product-part").append(flyer);
    $(".sp_clone").css({
      width: img[0].width,
      height: img[0].height,
      position: "fixed",
      top: img[0].offsetTop,
      left: img.offset().left,
      "z-index": "99",
    });

    let finish = $(".sp-cart");
    $(".sp_clone").animate(
      {
        // top: finish[0].offsetTop,
        top: finish[0].offsetTop + $(".time-part").height(),
        left: finish[0].offsetLeft + finish.width() / 2,
        width: 50, // 结束时的大小，根据需要调整
        height: 50, // 结束时的大小，根据需要调整
        opacity: 0.4,
      },
      500,
      "linear",
      function () {
        $(this).animate(
          {
            width: 0,
            height: 0,
            opacity: 0,
          },
          0,
          function () {
            $(this).detach();
          }
        );
      }
    );
  });
});
